export function computeKgeCO2ByParticipant(
  globalScoreTco2: number,
  totalCapacityOfAllDates: number,
): number {
  let kgeCO2ByParticipant = (globalScoreTco2 / totalCapacityOfAllDates) * 1000;
  kgeCO2ByParticipant = parseFloat(kgeCO2ByParticipant.toFixed(2));
  return kgeCO2ByParticipant;
}
